import ServiceTemplate from './ServiceTemplate';

const PeyroniesDisease = () => {
  const data = {
    title: 'Peyronies Disease',
    tagline: 'Treat Curvature. Restore Function.',
    description: 'Peyronies Disease involves scar tissue (plaque) forming inside the penis, causing curvature, pain, and discomfort. Early evaluation can help determine the best treatment approach.',
    causesTitle: 'What Causes Peyronies Disease?',
    causes: [
      'Injury or trauma to the penis',
      'Genetic factors',
      'Connective tissue disorders',
      'Age-related changes',
    ],
    symptoms: [
      'Curved erections',
      'Pain during erection',
      'Lumps or plaques under the skin',
      'Shortening of the penis',
      'Difficulty with intercourse',
    ],
    treatments: [
      'Oral medications',
      'Injection therapy',
      'Shockwave therapy',
      'Surgery (for advanced cases)',
    ],
    faqs: [
      { q: 'Will Peyronies Disease go away on its own?', a: 'In some cases, mild Peyronies may stabilize, but most cases benefit from treatment. Early intervention often leads to better outcomes.' },
      { q: 'Is treatment painful?', a: 'Most treatments are well-tolerated. Dr. Havkin will discuss what to expect with each option and help you choose the best approach for your situation.' },
      { q: 'How long does treatment take?', a: 'Treatment duration varies based on the severity and chosen approach. Some patients see improvement within weeks, while others may need several months of treatment.' },
    ],
    cta: 'Schedule an evaluation today.',
    seoTitle: "Peyronie's Disease Treatment Melbourne FL",
    seoDescription: "Peyronie's disease evaluation and treatment in Melbourne, FL. Dr. Havkin offers oral therapy, injections, and surgical correction for penile curvature. Call (321) 500-4545.",
    seoKeywords: "Peyronie's disease treatment Melbourne FL, penile curvature treatment, Peyronie's doctor, urologist Peyronie's disease",
    seoCanonical: '/services/peyronies-disease',
  };

  return <ServiceTemplate {...data} />;
};

export default PeyroniesDisease;
